<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Fees</h3>
          <v-spacer></v-spacer>
          <h3>Total Payments Received Today: {{otot_pmts|toCurrency}}</h3>
        </v-card-title>

        <v-card-text>
          <!-- <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete label="Select Class:"></v-autocomplete>

            </v-flex>
            <v-flex xs6>

              <v-btn color="success" @click="showF=!showF">Pay Fees</v-btn>
            </v-flex>


          </v-layout>-->
          <v-layout row wrap>
            <v-flex xs12>
              <!-- <v-btn color="success" @click="showF=!showF">Pay Fees</v-btn> -->

              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn
                    color="success"
                    @click="sendReminder()"
                    :loading="sloading"
                    v-on="on"
                  >Send Bill Reminder (All)</v-btn>
                </template>
                <span>Send fees reminder to guardians of all owing students</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn
                    color="success"
                    @click="exportOwing()"
                    v-on="on"
                  >Owing Students (Excel)</v-btn>
                </template>
                <span>Export owing students to excel</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn
                    color="success"
                    @click="exportAllPayments()"
                    v-on="on"
                  >All Payments (Excel)</v-btn>
                </template>
                <span>Export all fees payments to excel</span>
              </v-tooltip>
            </v-flex>

            <v-flex xs12>
              <v-card class="elevation-3">
                <v-card-title primary-title class="greyk lighten-4k">
                  <h4>Students</h4>

                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    style="max-width:40%"
                  ></v-text-field>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-data-table
                    :headers="fees_headers"
                    :items="feepayments"
                    class="elevation-0"
                    :search="search"
                    :loading="floading"
                    :key="refresh_key"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-center">{{ props.index + 1 }}</td>
                      <td class="text-xs-center">{{ props.item.s_bio.name }}</td>
                      <td class="text-xs-center">{{ props.item.rollno }}</td>
                      <td class="text-xs-center">{{ props.item.s_class?props.item.s_class.name:'N/A' }}</td>
                      <td class="text-xs-center">
                        <v-chip
                          v-bind:color="props.item.fee_status=='owing'?'red':'green'"
                        >{{ props.item.fee_status?props.item.fee_status:"N/A" }}</v-chip>
                      </td>
                      <td
                        class="text-xs-center"
                      >{{ props.item.fees_arrears?props.item.fees_arrears:'0.00' | toCurrency}}</td>
                      <td
                        class="text-xs-center"
                      >{{ props.item.tot_bill?props.item.tot_bill:0 | toCurrency }}</td>
                      <td
                        class="text-xs-center"
                      >{{ props.item.tot_paid?props.item.tot_paid:0 | toCurrency}}</td>
                      <td
                        class="text-xs-center"
                      >{{ props.item.s_discount?props.item.s_discount.name+'('+appendDiscValToName(props.item.s_discount)+')':'N/A'}}</td>

                      <td
                        class="text-xs-center"
                        style="font-weight:bold"
                      >{{ props.item.remaining_fee?props.item.remaining_fee:0 | toCurrency}}</td>

                      <td class="text-xs-center">
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-tooltip bottom>
                              <template v-slot:activator="{on}">
                                <v-btn
                                  flat
                                  icon
                                  color="blue"
                                  @click="viewPayments(props.item)"
                                  v-on="on"
                                >
                                  <v-icon>visibility</v-icon>
                                </v-btn>
                              </template>
                              <span>View payment history</span>
                            </v-tooltip>
                          </v-flex>

                          <v-flex xs6>
                            <v-tooltip bottom>
                              <template v-slot:activator="{on}">
                                <v-btn
                                  flat
                                  icon
                                  color="yellow"
                                  @click="sendReminder(props.item)"
                                  :loading="sloading"
                                  v-on="on"
                                >
                                  <v-icon>sms</v-icon>
                                </v-btn>
                              </template>
                              <span>Send fees reminder to {{props.item.s_bio.name+"'s"}} guardian</span>
                            </v-tooltip>
                          </v-flex>

                          <v-flex xs6>
                            <v-tooltip bottom>
                              <template v-slot:activator="{on}">
                                <v-btn
                                  flat
                                  icon
                                  color="pink"
                                  @click="attemptDiscount(props.item)"
                                  v-on="on"
                                >
                                  <v-icon>edit</v-icon>
                                </v-btn>
                              </template>
                              <span>Edit {{props.item.s_bio.name}}'s fees</span>
                            </v-tooltip>
                          </v-flex>

                          <v-flex xs6>
                            <v-tooltip bottom>
                              <template v-slot:activator="{on}">
                                <v-btn
                                  flat
                                  icon
                                  :color="$vuetify.theme.dark ? 'white' : 'black'"
                                  @click="attemptFeesPayment(props.item)"
                                  v-on="on"
                                >
                                  <v-icon>money</v-icon>
                                </v-btn>
                              </template>
                              <span>Pay fees</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!-- payment history dialog -->

      <fees-dialog pers title="Payment History" :show="showPH">
        <template v-slot:header-actions>
          <v-btn @click="showPH=!showPH" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <h5>Student: {{selected_std?selected_std.s_bio.name:''}}</h5>
          <v-data-table :headers="s_payments_headers" :items="selected_pmts">
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.index + 1 }}</td>
              <td class="text-xs-center">{{ props.item.rcpt_no }}</td>
              <td class="text-xs-center">{{ props.item.payment_date }}</td>
              <td class="text-xs-center">{{ props.item.amount | toCurrency}}</td>
              <td
                class="text-xs-center"
              >{{ props.item.recorded_by?props.item.recorded_by.name:'N/A'}}</td>
              <td class="text-xs-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn
                      flat
                      icon
                      color="red"
                      @click="deletepayment(props.item, props.index)"
                      v-on="on"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete payment</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </template>
      </fees-dialog>

      <!-- discount dialog -->

      <fees-dialog pers title="Edit Student Fees" :show="showFD">
        <template v-slot:header-actions>
          <v-btn @click="showFD=!showFD" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-text-field
            prepend-icon="person"
            readonly
            label="Student"
            :value="selected_std.s_bio.name+' ('+selected_std.rollno+')'"
          ></v-text-field>

          <v-autocomplete
            label="Personal Additional Charges"
            hint="Please make sure student's class has first been billed in order to see remaining additional charges"
            prepend-icon="money"
            :items="uca"
            item-text="charge_item"
            :return-object="true"
            :chips="true"
            :deletable-chips="true"
            :loading="faloading"
            v-model="discount_model.p_charges"
            :clearable="true"
            :multiple="true"
          ></v-autocomplete>

          <v-autocomplete
            label="Fee Discount"
            prepend-icon="money"
            :items="discounts"
            item-text="name"
            item-value="id"
            :loading="dloading"
            v-model="discount_model.fee_discount_id"
            :clearable="true"
          ></v-autocomplete>
        </template>

        <template v-slot:footer-actions>
          <v-btn
            style="cursor:pointer"
            color="success"
            @click="giveDiscount()"
            :loading="floading"
          >Save</v-btn>
          <v-btn @click="showFD=!showFD" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </fees-dialog>

      <!-- fees payment dialog -->
      <fees-dialog pers title="Fees Payment" :show="showF">
        <template v-slot:header-actions>
          <v-btn @click="showF=!showF" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="feespay_model.payment_date"
              persistent
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="feespay_model.payment_date"
                  label="Date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="feespay_model.payment_date" scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(feespay_model.payment_date)"
                >OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-text-field
              label="Receipt No."
              prepend-icon="receipt"
              v-model="feespay_model.rcpt_no"
              :rules="validRules.required"
            ></v-text-field>

            <v-autocomplete
              label="Select Student"
              prepend-icon="person"
              :items="students"
              item-text="s_bio.name"
              item-value="id"
              :loading="sloading"
              v-model="feespay_model.student_id"
              readonly
            ></v-autocomplete>

            <v-text-field
              label="Amount(GHS)"
              prepend-icon="money"
              v-model="feespay_model.amount"
              type="number"
              step="any"
              :rules="validRules.required"
            ></v-text-field>
          </v-form>
        </template>

        <template v-slot:footer-actions>
          <v-btn style="cursor:pointer" color="success" @click="payFees()" :loading="floading">Pay</v-btn>
          <v-btn @click="showF=!showF" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </fees-dialog>
    </v-container>
  </v-layout>
</template>

<script>
import Modal from "../../../components/Modal";
import { mapGetters } from "vuex";
import { json2excel, excel2json } from "js2excel";
import smsService from "../../../services/sms";
export default {
  name: "fees-view",
  metaInfo() {
    return { title: this.$t("fees") };
  },
  components: {
    "fees-dialog": Modal
  },
  created() {
    this.site_online = navigator.onLine ? true : false;
    this.$store.dispatch("settings/getAll");
    this.$store.dispatch("adcharges/getAll");
    this.$store.dispatch("billings/getAll");
    this.$store.dispatch("students/getAll");
    this.$store.dispatch("feepayments/getAll");
    this.$store.dispatch("discounts/getAll");

    this.sms_senderid = (this.settings.sms || {}).senderid;
    this.sms_apiKey = (this.settings.sms || {}).apiKey;
    // this.$store.dispatch("settings/getAll");
    if (this.site_online && this.sms_apiKey) {
      this.$store.dispatch("sms/getBalance");
    }
  },
  data() {
    return {
      search: "",
      showB: false,
      showF: false,
      showPH: false,
      showFD: false,
      modal: false,
      payIndex: -1,
      refresh_key: 0,
      cls_billsum: [],
      site_online: false,
      sms_senderid: "",
      sms_apiKey: "",
      selected_pmts: [],
      discount_model: {
        id: "",
        fee_discount_id: "",
        p_charges: null
      },

      selected_std: {
        s_bio: {
          name: ""
        }
      },
      feesbill_model: {
        classes: [],
        feestr_id: ""
      },
      feesbill_modelcp: {
        classes: [],
        feestr_id: ""
      },
      feespay_model: {
        student_id: "",
        amount: "",
        rcpt_no: "",
        payment_date: new Date().toISOString().substr(0, 10)
      },
      feespay_modelcp: {
        student_id: "",
        amount: "",
        rcpt_no: "",
        payment_date: new Date().toISOString().substr(0, 10)
      },
      s_payments_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn"
        },
        {
          text: "Receipt No.",
          align: "center",
          sortable: false,
          value: "rcpt_no"
        },
        {
          text: "Payment Date",
          align: "center",
          sortable: false,
          value: "payment_date"
        },
        {
          text: "Amount Paid (GHS)",
          align: "center",
          sortable: false,
          value: "amount"
        },
        {
          text: "Recorded By",
          align: "center",
          sortable: false,
          value: "recorded_by.name"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: ""
        }
      ],
      fees_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "s_bio.name"
        },
        {
          text: "Roll. No.",
          align: "center",
          sortable: true,
          value: "rollno"
        },
        {
          text: "Class",
          align: "center",
          sortable: true,
          value: "s_class.name"
        },
        {
          text: "Fee Status",
          align: "center",
          sortable: false,
          value: "fee_status"
        },
        {
          text: "Last Term's Arrears",
          align: "center",
          sortable: false,
          value: "arrears"
        },
        {
          text: "Tot. Billed Amt.",
          align: "center",
          sortable: true,
          value: "tot_bill"
        },
        {
          text: "Total Paid",
          align: "center",
          sortable: true,
          value: "tot_paid"
        },
        {
          text: "Discount",
          align: "center",
          sortable: true,
          value: "s_discount.name"
        },
        {
          text: "Current Arrears",
          align: "center",
          sortable: false,
          value: "arrears"
        },

        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "name"
        }
      ],
      fpselstd: null
    };
  },
  methods: {
    exportOwing() {
      if (!confirm("Click okay to confirm list export or cancel.")) {
        //confirm you want to send this reminder
        return;
      }

      let data = this.feepayments
        .filter(x => {
          return x.fee_status == "owing";
        })
        .map(s => {
          return {
            Roll_No: s.rollno,
            Name: s.s_bio.name,
            Class: s.s_class.name,
            Arrears: s.remaining_fee
          };
        });

      try {
        json2excel({
          data,
          name: "owing-students-" + new Date().toISOString().substr(0, 10),
          formateDate: "yyyy/mm/dd"
        });
      } catch (e) {
        console.error("export error");
      }
    },
    exportAllPayments() {
      if (!confirm("Click okay to confirm list export or cancel.")) {
        //confirm you want to send this reminder
        return;
      }

      let data = this.feepayments
        .map(s => {
          return {
            Roll_No: s.rollno,
            Name: s.s_bio ? s.s_bio.name : "N/A",
            Class: s.s_class ? s.s_class.name : "N/A",
            'Total Bill':s.tot_bill,
            'Total Paid':s.tot_paid,
            Arrears: s.remaining_fee
          };
        });

      try {
        json2excel({
          data,
          name: "all-fees-payments-" + new Date().toISOString().substr(0, 10),
          formateDate: "yyyy/mm/dd"
        });
      } catch (e) {
        console.error("export error");
      }
    },
    attemptFeesPayment(std) {
      if (std.fee_status != "owing") {
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: std.s_bio.name + " does not owe any fees.",
          title: "fee payment",
          modal: false
        });

        return;
      }
      this.payIndex = this.feepayments.indexOf(std);
      this.feespay_model.student_id = std.id;
      this.fpselstd = std;
      this.showF = true;
    },

    attemptDiscount(std) {

      //console.log(std)
      this.selected_std = std;
      this.payIndex = this.feepayments.indexOf(std);
      this.discount_model.id = std.id;
      this.discount_model.fee_discount_id = std.fee_discount_id;
      this.discount_model.p_charges = JSON.parse(std.p_charges)
      this.showFD = true;
    },
    giveDiscount() {
      this.$store.dispatch("feepayments/update", {
        index: this.payIndex,
        discount_details: this.discount_model
      });

      if (this.ferrors == null) {
        this.discount_model = {
          id: "",
          fee_discount_id: "",
          p_charges: {}
        };
        this.payIndex = -1;
        this.showFD = false;
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Student Fee edited successfully.",
          title: "discount",
          modal: false
        });
      } else {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry, an error occured and student's fee could not be edited.",
          title: "discount",
          modal: false
        });
      }
    },
    payFees() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.$store.dispatch("feepayments/add", {
        index: this.payIndex,
        fee_obj: this.feespay_model
      });

      if (this.ferrors == null) {
        let amt_paid = this.feespay_model.amount;
        let dt_paid = this.feespay_model.payment_date;

        let ars_remaining =
          parseFloat(this.feepayments[this.payIndex].remaining_fee) -
          parseFloat(amt_paid);

        this.feespay_model = this.feespay_modelcp;
        this.payIndex = -1;
        this.showF = false;
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Fee paid successfully.",
          title: "fee paying",
          modal: false
        });

        if (
          this.site_online &&
          this.settings.sms.alert_status &&
          Number(this.settings.sms.alert_status) == 1 &&
          this.fpselstd.s_guardian.phone
        ) {
          //console.log("sh")
          if (this.sms_balance < 1) {
            this.$store.dispatch("responseMessage", {
              type: "warning",
              text:
                "System attempted notifying student's guardian of this payment but an error occured. Please contact administrator to check sms settings/balance ",
              title: "SMS",
              modal: false
            });
            this.fpselstd = null;
            return;
          }

          this.$store.dispatch("sms/send", {
            to: this.fpselstd.s_guardian.phone,
            msg:
              "Payment of GHS " +
              amt_paid +
              " received for " +
              this.fpselstd.s_bio.name +
              "'s fees on " +
              dt_paid +
              ". REMAINING FEE: GHS " +
              ars_remaining
          }).catch(() => {});

          this.fpselstd = null;
        }
      } else {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry, an error occured and fee paying was unsuccessful.",
          title: "fee paying",
          modal: false
        });
      }
    },
    deletepayment(feepayment, pmt_index) {
      if (confirm("Are you sure you want to delete this fee payment?")) {
        const index = this.feepayments.findIndex(
          s => s.s_payments && s.s_payments.some(p => p.id === feepayment.id)
        );
        this.$store.dispatch("feepayments/delete", {
          feepayment,
          index,
          pmt_index
        }).then(() => {
          if (this.ferrors == null) {
            this.selected_pmts = this.selected_pmts.filter(p => p.id != feepayment.id);
            this.$store.dispatch("responseMessage", {
              type: "success",
              text: "Fee payment deleted successfully.",
              title: "delete fee payment",
              modal: false
            });
          } else {
            this.$store.dispatch("responseMessage", {
              type: "warning",
              text: "Sorry, an error occured and fee payment could not be deleted.",
              title: "delete fee payment",
              modal: false
            });
          }
        });
      }
    },

    viewPayments(std) {
      this.selected_pmts = std.s_payments ? std.s_payments : [];
      this.selected_std = std;
      this.showPH = true;
    },

    async sendReminder(selbill = null) {
      if (!this.site_online) {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry,message could not be sent. please check your network.",
          title: "SMS",
          modal: false
        });
        return;
      }

      if (!confirm("Are you sure you want to send this reminder?")) {
        return;
      }

      await smsService.sendFeeReminder(this.$store, {
        feepayments: this.feepayments,
        selbill,
        sms_balance: this.sms_balance
      });
    },

    appendDiscValToName(val) {
      if (val.val_type == "percentage") {
        return val.val + "%";
      } else {
        return "GHS" + val.val;
      }
    }
  },
  watch: {
    showFD(val) {
      if (val == false) {
        this.discount_model = {
          id: "",
          fee_discount_id: "",
          p_charges: null
        };
      }
    }
  },
  computed: {
    ...mapGetters({
      students: "students/STUDENTS",
      sloading: "students/STUDENT_LOADING",

      feepayments: "feepayments/FEEPAYMENTS",
      ferrors: "feepayments/FEEPAYMENT_ERROR",
      floading: "feepayments/FEEPAYMENT_LOADING",

      bills: "billings/BILLINGS",
      c_bill_sums: "billings/C_BILL_SUMS",
      bloading: "billings/BILLING_LOADING",
      berrors: "billings/BILLING_ERROR",

      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      sloading: "settings/SETTING_LOADING",

      adcharges: "adcharges/ADCHARGES",
      faerrors: "adcharges/ADCHARGE_ERROR",
      faloading: "adcharges/ADCHARGE_LOADING",

      sms_balance: "sms/SMS_BALANCE",
      smerrors: "sms/SMS_ERROR",
      smloading: "sms/SMS_LOADING",
      //sms_recipients: "sms/SMS_RCPTS"

      discounts: "discounts/DISCOUNTS",
      derrors: "discounts/DISCOUNT_ERROR",
      dloading: "discounts/DISCOUNT_LOADING"
    }),
    otot_pmts() {
      if (!this.feepayments) {
        return 0;
      }
      const today = this.todayStr;
      let c = 0;
      this.feepayments.forEach(fp => {
        if (fp.s_payments && fp.s_payments.length) {
          fp.s_payments.forEach(p => {
            if (p.payment_date && p.payment_date.substring(0, 10) === today) {
              c += parseFloat(p.amount) || 0;
            }
          });
        }
      });
      return c;
    },
    todayStr() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      const d = String(now.getDate()).padStart(2, "0");
      return y + "-" + m + "-" + d;
    },
    uca() {
      //uca = unselected_class_adcharges

      if (this.selected_std.id) {
        let sel_std_clsid = this.selected_std.class_id; //getting class id to get class bill

        let sel_std_cbill = this.bills
          ? this.bills.filter(x => {
              return x.id == sel_std_clsid;
            })
          : null; //getting class bill

        let sel_std_adchgs =
          sel_std_cbill.length > 0
            ? sel_std_cbill[0].feestr.adcharges.map(x => x.id)
            : null;

        let c = sel_std_adchgs
          ? this.adcharges.filter(x => {
              if (sel_std_adchgs.indexOf(x.id) < 0) {
                return true;
              } else {
                return false;
              }
            })
          : [];

        return c;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/accountant/fees/fees.vue